var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86,
    height: 62,
    viewBox: "0 0 86 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#0E1B42",
    fillOpacity: 0.343,
    d: "M26.24 58.855c-.749.096-1.511.145-2.285.145C14.039 59 6 50.929 6 40.972c0-9.848 7.864-17.851 17.63-18.025l-.002-.33C23.628 10.126 33.713 0 46.153 0c12.44 0 22.525 10.126 22.525 22.617 0 .134-.001.267-.004.4C77.827 23.845 85 31.568 85 40.973c0 8.722-6.168 15.997-14.364 17.667V59H26.24v-.145z",
    opacity: 0.155,
    transform: "translate(-920 -316) translate(921 316)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#979797",
    strokeOpacity: 0.273,
    d: "M20.24 60.855c-.749.096-1.511.145-2.285.145C8.039 61 0 52.929 0 42.972c0-9.848 7.864-17.851 17.63-18.025l-.002-.33C17.628 12.126 27.713 2 40.153 2c12.44 0 22.525 10.126 22.525 22.617 0 .134-.001.267-.004.4C71.827 25.845 79 33.568 79 42.973c0 8.722-6.168 15.997-14.364 17.667V61H20.24v-.145z",
    transform: "translate(-920 -316) translate(921 316)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0E1B42",
    fillOpacity: 0.343,
    d: "M42.008 37.144v9.728c0 .624-.5 1.128-1.117 1.128s-1.116-.504-1.116-1.128v-9.728h-9.659c-.617 0-1.116-.505-1.116-1.128 0-.624.5-1.128 1.116-1.128h9.66v-9.76c0-.624.498-1.128 1.115-1.128.618 0 1.117.504 1.117 1.128v9.76h9.876c.617 0 1.116.504 1.116 1.128 0 .623-.5 1.128-1.116 1.128h-9.876z",
    transform: "translate(-920 -316) translate(921 316) matrix(1 0 0 -1 0 72)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgCloud);
export default __webpack_public_path__ + "static/media/img-cloud.03a612b863d4e68f23969fcea717a6b3.svg";
export { ForwardRef as ReactComponent };